import { makeStyles, Typography } from '@material-ui/core'
import * as colors from '../../utils/colors'
import { FONT_WEIGHTS } from '../../utils'

const useStyles = makeStyles(() => ({
	root: {
		display: 'flex',
		flexDirection: 'column'
	},
	container: {
		backgroundColor: colors.purple[100],
		flex: 1,
		padding: 12,
		paddingTop: 16,
		paddingBottom: 16,
		borderRadius: 10
	},
	text: {
		fontSize: 14,
		lineHeight: '21px',
		color: colors.purple[900],
		padding: 0,
		margin: 0
	}
}))

/**
 * A light purple container with dark purple text
 * @param {{text?: string}} props
 * @returns
 */
const StyledPreviewText = ({ text = '', header = '' }) => {
	const classes = useStyles()
	return (
		<div className={classes.root}>
			{header > '' ? <Typography variant="overline">{header}</Typography> : null}
			<div className={classes.container}>
				<span className={classes.text}>{text}</span>
			</div>
		</div>
	)
}
export default StyledPreviewText
